import React from "react";
import MetricCard from "../../components/cards/MetricCard";

function EngineeringHighlightsSection() {
  return (
    <section className="bg-transparent p-4 sm:p-8 font-sans">
      <div className="mx-auto max-w-7xl w-full">
        {/* Section Header */}
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-gsf-bronze">
              Engineering Impact
            </span>

            <h2 className="mt-1 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">
              Real Systems. Real Users. Real Impact.
            </h2>
          </div>

          <p className="max-w-md text-sm font-medium text-slate-600 md:text-right">
            A snapshot of production software, scalable backend engineering,
            intelligent applications, and real-time data platforms built across
            multiple industries.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-12">
          {/* Users */}

          <MetricCard
            metric="6000+"
            title="Registered Users"
            badge="Production Platform"
            description="Designed and developed a production-grade digital learning platform supporting more than 6,000 registered users through scalable backend services, REST APIs, and multi-platform applications."
            className="lg:col-span-7"
          />

          {/* Production Systems */}

          <MetricCard
            metric="5+"
            title="Production Systems"
            badge="Real-World Solutions"
            description="Delivered production software including digital learning platforms, enterprise systems, healthcare dashboards, and real-time monitoring solutions."
            className="lg:col-span-5"
          />

          {/* Backend */}

          <MetricCard
            metric="Backend"
            title="Engineering"
            badge="Core Expertise"
            description="Focused on building scalable backend services using Python and Golang with REST APIs, authentication, PostgreSQL, and modern software architecture."
            className="lg:col-span-4"
          />

          {/* AI */}

          <MetricCard
            metric="AI"
            title="Intelligent Systems"
            badge="Applied AI"
            description="Applied artificial intelligence through machine learning, computer vision, and LLM integration to develop intelligent features for production software."
            className="lg:col-span-4"
          />

          {/* Real-Time */}

          <MetricCard
            metric="Real-Time"
            title="Data Systems"
            badge="IoT Platforms"
            description="Designed backend services and data processing pipelines for IoT platforms, transforming real-time sensor data into operational dashboards and actionable insights."
            className="lg:col-span-4"
          />
        </div>
      </div>
    </section>
  );
}

export default EngineeringHighlightsSection;
